import React from 'react'

import Svg, { Path } from 'react-native-svg'

const CategoryNotEligibleSvg = ({ size = 90, ...props }) => {
  return (
    <Svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M48.6663 74.9775C28.7477 74.9775 12.4987 58.7325 12.4987 38.8141C12.4987 18.8957 28.7477 2.64648 48.6663 2.64648C68.5847 2.64648 84.834 18.8957 84.834 38.8141C84.834 58.7325 68.5847 74.9775 48.6663 74.9775Z"
        fill="#D1D9E9"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.9317 38.8141C18.9317 46.2125 21.1529 53.0899 24.9633 58.8224C26.4328 61.0307 28.1413 63.0725 30.0508 64.9051C35.8259 70.4497 43.438 74.0932 51.8828 74.8365C50.8235 74.9306 49.7514 74.9775 48.6665 74.9775C46.9108 74.9775 45.1808 74.8537 43.4892 74.6101C43.2714 74.5803 43.0535 74.5461 42.8399 74.5118C25.6339 71.7268 12.4988 56.8018 12.4988 38.8141C12.4988 18.8401 28.6923 2.64648 48.6665 2.64648C49.7514 2.64648 50.8235 2.69343 51.8828 2.78748C33.4125 4.4149 18.9317 19.9208 18.9317 38.8141Z"
        fill="#C2CBDD"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M48.6667 42.2998C61.6949 42.2998 72.421 52.1714 73.7793 64.8411C67.2737 71.116 58.4228 74.9776 48.6667 74.9776C46.9109 74.9776 45.181 74.8537 43.4894 74.6102C35.8005 73.5081 28.8891 69.984 23.5581 64.8411C24.9121 52.1672 35.6382 42.2998 48.6667 42.2998Z"
        fill="#E5EAF3"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51.8789 42.5049C36.8471 44.4143 30.7901 55.7896 29.3974 69.4202C27.2916 68.0959 25.3353 66.5582 23.5582 64.8411C24.9123 52.1672 35.6383 42.2998 48.6668 42.2998C49.756 42.2998 50.8282 42.3681 51.8789 42.5049Z"
        fill="#D8DFEE"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M48.6658 41.931C41.7354 41.931 36.0843 36.2799 36.0843 29.3538C36.0843 22.4234 41.7354 16.7764 48.6658 16.7764C55.592 16.7764 61.2432 22.4234 61.2432 29.3538C61.2432 36.2799 55.592 41.931 48.6658 41.931Z"
        fill="white"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.2529 29.3538C39.2529 35.7665 44.0499 41.0559 50.248 41.8343C49.7305 41.8975 49.2003 41.931 48.6658 41.931C41.7187 41.931 36.0886 36.3009 36.0886 29.3538C36.0886 22.4065 41.7187 16.7764 48.6658 16.7764C49.2003 16.7764 49.7305 16.8101 50.248 16.8732C44.0499 17.6517 39.2529 22.941 39.2529 29.3538Z"
        fill="#F5F7FB"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.0538 50.1527L8.12433 75.5121C6.89704 77.5959 6.89704 80.1134 8.12433 82.1972C9.35162 84.284 11.5756 85.5397 14.03 85.5397H43.8829C46.3375 85.5397 48.5583 84.284 49.7856 82.1972C51.0129 80.1134 51.0129 77.5959 49.7856 75.5121L34.8591 50.1527C33.6318 48.066 31.4111 46.8071 28.9565 46.8071C26.5021 46.8071 24.2811 48.066 23.0538 50.1527Z"
        fill="#FE646F"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.8672 46.8655C29.5685 46.827 29.2648 46.8071 28.9573 46.8071C26.5029 46.8071 24.2819 48.066 23.0546 50.1527L8.12513 75.5121C6.89784 77.5959 6.89784 80.1134 8.12513 82.1972C9.35242 84.284 11.5764 85.5397 14.0308 85.5397H15.8506C13.3962 85.5397 11.1721 84.284 9.94493 82.1972C8.71763 80.1134 8.71763 77.5959 9.94493 75.5121L24.8744 50.1527C25.948 48.3274 27.7818 47.1355 29.8672 46.8655Z"
        fill="#FD4755"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.1316 51.894L11.202 77.2534C10.6102 78.2615 10.6102 79.447 11.202 80.4554C11.797 81.4606 12.8435 82.0563 14.0303 82.0563H43.8832C45.0669 82.0563 46.1166 81.4606 46.7084 80.4554C47.3003 79.447 47.3003 78.2615 46.7084 77.2534L31.782 51.894C31.1901 50.8858 30.1405 50.293 28.9568 50.293C27.77 50.293 26.7234 50.8858 26.1316 51.894Z"
        fill="#ECEFF5"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.0634 82.0563H43.8832C45.0669 82.0563 46.1166 81.4606 46.7084 80.4554C47.3003 79.447 47.3003 78.2615 46.7084 77.2534L31.782 51.894C31.1901 50.8858 30.1405 50.293 28.9568 50.293C28.6415 50.293 28.3359 50.3349 28.0462 50.4153C28.8462 50.6375 29.5277 51.1537 29.9622 51.894L44.8886 77.2534C45.4805 78.2615 45.4805 79.447 44.8886 80.4554C44.2968 81.4606 43.2472 82.0563 42.0634 82.0563Z"
        fill="#A5AFC3"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.9569 71.6775C29.8545 71.6775 30.5882 70.9822 30.6202 70.1019L31.044 58.6637C31.0582 58.2025 30.9016 57.8007 30.5774 57.4688C30.2498 57.1369 29.8472 56.9692 29.3772 56.9692H28.5365C28.0665 56.9692 27.6604 57.1369 27.3363 57.4688C27.0086 57.8007 26.8519 58.2025 26.8697 58.6637L27.29 70.1019C27.322 70.9822 28.0594 71.6775 28.9569 71.6775Z"
        fill="#FE646F"
      />
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.9564 78.0536C27.781 78.0536 26.8229 77.1137 26.8229 75.9608C26.8229 74.8079 27.781 73.8682 28.9564 73.8682C30.1317 73.8682 31.0898 74.8079 31.0898 75.9608C31.0898 77.1137 30.1317 78.0536 28.9564 78.0536Z"
        fill="#FE646F"
      />
    </Svg>
  )
}

export default CategoryNotEligibleSvg
